import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-all",
  "use": "icon-all-usage",
  "viewBox": "0 0 9 5",
  "content": "<symbol viewBox=\"0 0 9 5\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-all\">\r\n  <path d=\"M1.5 3H7.5C7.775 3 8 2.775 8 2.5C8 2.225 7.775 2 7.5 2H1.5C1.225 2 1 2.225 1 2.5C1 2.775 1.225 3 1.5 3ZM0.5 5H6.5C6.775 5 7 4.775 7 4.5C7 4.225 6.775 4 6.5 4H0.5C0.225 4 0 4.225 0 4.5C0 4.775 0.225 5 0.5 5ZM2 0.5C2 0.775 2.225 1 2.5 1H8.5C8.775 1 9 0.775 9 0.5C9 0.225 8.775 0 8.5 0H2.5C2.225 0 2 0.225 2 0.5Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol